var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 18.1035H1.125V10.6035H4.125",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 12.8535H8.625",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 15.1035H8.625",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 10.6035H8.625",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 5.35352V2.35352L17.625 4.60352V18.1035H4.125V7.60352H11.625V18.1035",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 15.1035V7.60352",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.e30759bb739bed0ddf15d6abe2669403.svg";
export { ForwardRef as ReactComponent };